module.exports = {
  success: 'Save',
  cancel: 'Cancel',
  remove: 'Delete',
  warning: 'Warning',
  confirm: 'Confirm',
  fillFromTemplate: 'Fill in from template',
};
